import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/Card/Card';
import { Button } from '@/components/ui/Button/Button';
import { usePageHeader } from '@/hooks/usePageHeader';
import { PageContainer } from '@/components/ui/PageContainer';
import { t } from '@/lib/i18n';

export function DangerPage() {
  usePageHeader({ title: t('Danger Zone'), breadcrumbs: [] });

  return (
    <PageContainer>

      <div className="space-y-6">
        {/* Content */}
      <Card>
        <CardHeader>
          <CardTitle>Account Deactivation</CardTitle>
          <CardDescription>Permanently deactivate your account and delete all data</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Deactivation will sign you out everywhere and restrict access. Organization ownership may prevent deactivation.</p>
        </CardContent>
        <CardFooter>
          <Button variant="danger" disabled>Deactivate account (coming soon)</Button>
        </CardFooter>
      </Card>
      </div>
    </PageContainer>
  );
}


